import { useTranslation } from "react-i18next";
import { Truck, Check } from "lucide-react";
import { formatCurrency } from "@/lib/product";

/** Duwtje in de catalogus: hoeveel er nog nodig is voor gratis verzending. */
export const FreeShippingNudge = ({ verzending, testId = "free-shipping-nudge" }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  if (!verzending?.gratisVanaf) return null;

  const gehaald = verzending.gratis;
  const voortgang = gehaald
    ? 100
    : Math.min(100, Math.round(((verzending.gratisVanaf - verzending.tekortVoorGratis) / verzending.gratisVanaf) * 100));

  return (
    <div
      className="mt-4 rounded-lg border bg-card p-4 shadow-sm transition-colors"
      data-testid={testId}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-medium">
          {gehaald ? (
            <Check className="h-4 w-4 text-[hsl(var(--success,142_71%_35%))]" aria-hidden="true" />
          ) : (
            <Truck className="h-4 w-4 text-primary" aria-hidden="true" />
          )}
          {gehaald
            ? t("shipping.nudgeReached", { vanaf: formatCurrency(verzending.gratisVanaf, lang) })
            : t("shipping.nudgeRemaining", { ontbreekt: formatCurrency(verzending.tekortVoorGratis, lang) })}
        </p>
        <span className="text-xs text-muted-foreground" data-testid={`${testId}-threshold`}>
          {t("shipping.nudgeThreshold", { vanaf: formatCurrency(verzending.gratisVanaf, lang) })}
        </span>
      </div>
      <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-secondary">
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-500 ease-out"
          style={{ width: `${voortgang}%` }}
          data-testid={`${testId}-progress`}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};
